import React, { useContext, useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import cleanSheetUrl from "../helpers/cleanSheetUrl";
import "../content/base_2.0.css";
import "../content/home_2.0.css";
import "../content/ccbh-tableau-portal_2.0.css";
import "./dashboardrow.css";

import configData from "../config/config.json";
import TableauViz2 from "./tableauviz";


const TableauDashboardListRow = ({dashboard, fakefunc}) => {
    let navigate = useNavigate();

    const location = useLocation();
    const siteUrl = location.state?.loginResult?.sitePage.siteUrl;
    const lr = location.state?.loginResult;

    const imageSRC = "data:image/png;base64," + dashboard.previewImage; 
    const imageDivId = dashboard.name + "_thumb";
    const url = dashboard.webPageUrl;
    const dashboardUrl = dashboard.urlName;
    const [selectedPage, setSelectedPage] = useState();

    // sheets/ChecksPaidSummary
    const dashboardCardTitle = dashboard.name;
    //const [view, setViewName] = useState('');
    var view = '';
    if(dashboard.pages.length === 0){
        view = dashboard.urlName;
    }else{
        view = cleanSheetUrl(dashboard.pages[0]?.url); //.replace('sheets/','');
    }
    const userName = location.state?.loginResult?.user.webuserId;
    const siteId = location.state?.loginResult?.sitePage.siteName;

    const getTicket =  async(username, siteId) => {
            try{
                const url = configData.CCBHTableauAPIServer + '/ticket'; 
                const response = await fetch(url, { 
                    method:"GET", 
                    headers: {
                        'UserID': username,
                        'SiteID': siteId
                    },
                });
                console.log(response);
                const responseJson = await response.json();
        
                return responseJson;
            }catch(err){
                console.log(err.message);
            }        
    };

    const makeVizUrl = async() => {
        const ticket = await getTicket(userName, siteId); 
        var vizUrl = configData.TableauBackEndServer + "/trusted/" + ticket + "/t/" + siteId + "/views/" + view;
        return vizUrl;
    };

    const showDashboard = async() => {
        let vizUrl = await makeVizUrl();
        for(const p in dashboard.pages){
            let pu = dashboard.pages[p].url.replace("sheets/","");
            if(pu === view){
                let sp = p.name + ":" + url;
                setSelectedPage(sp);
            }
        }
        //navigate("/dashboard", {state : {id:1, vizUrl: vizUrl, dashboard: dashboard, siteId: siteId, userName: userName, view: view, isFavorite:dashboard.pages[0].bookmarked, loginResult: lr, selectedPage: selectedPage}});
        return(
        <TableauViz2  vizUrl={vizUrl} 
                      dashboard={dashboard} 
                      siteId={siteId} 
                      userName={userName}
                      view={view} 
                      isFavorite={dashboard.pages[0].bookmarked} 
                      loginResult={lr} 
                      selectedPage={selectedPage} 
                      />
        );

    };

    const resetActiveButton = () =>{
        let currentActive = document.getElementsByClassName("activeButton");
        if(currentActive.length > 0){
            for(var idx =0; idx < currentActive.length; ++idx){
                currentActive[idx].classList.remove('activeButton');
                //currentActive[idx].classList.add('dashboardLink');
            }
        }
    }

    const linkClick = async(event) => {
        /* clear current loaded dashboard */
        fakefunc('');
        resetActiveButton();
        let vizUrl = await makeVizUrl();
        fakefunc(vizUrl, dashboard, siteId, userName, view, lr);
        //event.target.classList.remove('dashboardLink');
        event.target.classList.add("activeButton");
    }


    return(
        <>
            <button type="button" className="dashboardLink" onClick={linkClick}>{dashboardCardTitle}</button>
        </>
    );
};


export default TableauDashboardListRow;